// Pflichtfeld-Prüfung der Personen-Vollanlage (NewPrivateContactForm) — als pure
// Funktion herausgelöst, damit die Regel testbar ist und an EINER Stelle lebt
// (Gegenstück zu newCompanyRequired.ts).
//
// **Pflicht sind nur noch Nachname und Vorname** (PO-Notiz 02.08. — dort für die
// Firma als „Name, Rechtsform" festgehalten; dieselbe Linie gilt hier). Die
// Rufnummer-Pflicht für Kunde/Sonstige ist entfallen: eine Person wird oft aus
// einer Empfehlung, einer Mail oder einem Registerauszug heraus erfasst, wo noch
// keine Nummer vorliegt. Erfassen kann man sie natürlich weiterhin.

export type PrivateRequiredFields = {
  lastname?: string;
  firstname?: string;
  mobilePrivate?: string;
  phonePrivate?: string;
  /**
   * Ansprechpartner bei einem Produktpartner. Von vielen Gesellschaftskontakten
   * kennt man zunächst nur die E-Mail-Adresse.
   */
  isApProduktpartner?: boolean;
  /**
   * Kontaktstatus „Interessent" (der Default der Anlage). Ein Interessent wird
   * oft aus einer Empfehlung oder einer reinen Mailanfrage heraus erfasst, wo
   * noch gar keine Rufnummer vorliegt. Name bleibt Pflicht.
   */
  isInteressent?: boolean;
};

const filled = (v?: string): boolean => (v ?? "").trim() !== "";

/**
 * Die Pflichtfeld-Checks der Personen-Anlage in fester Reihenfolge (für den
 * Fortschrittszähler `RequiredFieldsProgress`).
 */
export function privateRequiredChecks(f: PrivateRequiredFields): boolean[] {
  return [filled(f.lastname), filled(f.firstname)];
}
